import { useEffect, useState } from "react";
import { infomacesToken } from "../../services/api";
import Loading from "../../utils/Loading";

function DashboardAluno() {
  const [idAluno, setIdAluno] = useState(null);
  const [idEscola, setIdEscola] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const idA = infomacesToken()?.id_pessoa;
    const idE = infomacesToken()?.id_escola;
    if (idA) {
      setIdAluno(idA);
    } else {
      alert("Erro ao buscar id do aluno.");
      return;
    }

    if (idE) {
      setIdEscola(idE);
    } else {
      alert("Erro ao buscar id da escola.");
      return;
    }
  }, []);

  useEffect(() => {
    if (idAluno && idEscola) {
      setLoading(true);
    }
  }, [idAluno, idEscola]);

  const dashboardUrl = `https://conexao-literaria.institutoyoux.org.br/dashboard/?id_escola=${idEscola}&id_aluno=${idAluno}&embed=true`; 

  return (
    <div>
      {idEscola && idAluno && (
        <iframe
          title="dashboard aluno"
          style={{ width: "95%", border: "none", height: "85vh" }}
          src={dashboardUrl}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            alert("Erro ao carregar o dashboard");
          }}
        ></iframe>
      )}
      {loading && (
        <Loading />
      )}
    </div>
  );
}

export default DashboardAluno;
